import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            cash: [],
            allCashBalance: null
        };
    },

    mutations: {
        setCash(state, data) {
            state.cash = data;
        },
        setMeta(state, data) {
            state.allCashBalance = data.allCashBalance;
        },
        clearStore(state) {
            state.cash = {};
            state.allCashBalance = null;
        }
    },
    actions: {
        async getList({ state, commit }, params) {
            try {
                const response = await api.get('/cash/?' + qs.stringify(params));
                commit('setCash', response.data.data);
                commit('setMeta', response.data.meta);
            } catch (e) {
                console.log(e);
                throw new Error(e);
            }
        },
        async getCash(context, id) {
            try {
                return await api.get('/cash/' + id);
            } catch (e) {
                console.log(e);
                throw new Error(e);
            }
        }
    }
};

export default store;
